import { Box, InputAdornment } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import styles from "./addVehilceForm.module.scss";
import FormikControl from "../../../../components/formComponents/FormikControl";
import i18next from "i18next";
import {
  dateFormats,
  dateInputValidation,
  dropdownValueYesNoNeumeric,
  getDropDownValue,
} from "../../../../config/appConfig";
import { FieldArray, useFormikContext } from "formik";
import _ from "lodash";
import Button from "../../../../components/buttons/Buttons";

import moment from "moment";
import { useApiErrorModalContext } from "../../../../errorHandling/ApiErrorModalContext";
import { getDealerDropDownList } from "../../../../services/APIService";
import PropTypes from "prop-types";

const VehicleFormSection = (props) => {
  const { assignCertificatesOptions } = props;
  const [dealerDropdownList, setDealerDropdownList] = useState([]);
  const { setApiErrorModalState } = useApiErrorModalContext();
  const [isDealerListLoading, setIsDealerListLoading] = useState(false);

  const fetchDealerDropDownList = (params = {}) => {
    getDealerDropDownList(params)
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          setIsDealerListLoading(false);
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setIsDealerListLoading(false);

          setDealerDropdownList(response);
        }
      })
      .catch((err) => {
        setIsDealerListLoading(false);

        setApiErrorModalState({ error: err });
      });
  };

  useEffect(() => {
    fetchDealerDropDownList();
    if (document.getElementById("addVehilceFormWrapper")) {
      document.getElementById("addVehilceFormWrapper").scrollIntoView =
        function () {};
      document.getElementById("license-field").focus();
      setIsDealerListLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onDealerInputChange = (searchTerm) => {
    setIsDealerListLoading(true);

    if (!isDealerListLoading || searchTerm.length === 0) {
      fetchDealerDropDownList({ searchTerm: searchTerm });
    }
  };
  const formikProps = useFormikContext();

  const setDropdownValue = (
    value,
    dropdownOptions,
    name,
    date,
    hasError = false
  ) => {
    let selectedOption = getDropDownValue(value, dropdownOptions);
    if (hasError) {
      formikProps.setFieldTouched(name, true);
      formikProps.setFieldValue(name, null);
    } else {
      formikProps?.setFieldValue(name, selectedOption);
      formikProps?.setFieldTouched(name, false);

      formikProps?.setFieldValue(date, moment().format());
      formikProps?.setFieldTouched(date, false);
    }
  };

  const isDuplicateCertificate = (certificateArry, selectedCertificate) => {
    let duplicateCertificates = certificateArry.filter((certificate) => {
      if (_.isEmpty(certificate.certificate_Name)) {
        return false;
      } else {
        return (
          certificate?.certificate_Name?.value === selectedCertificate.value
        );
      }
    });
    return !_.isEmpty(duplicateCertificates);
  };

  const hasErrorCheck = (formikProps, collection, name, index) => {
    if (formikProps?.touched?.[collection]) {
      if (formikProps?.touched?.[collection]?.[index]) {
        if (
          formikProps?.touched?.[collection]?.[index]?.[name] &&
          formikProps?.errors?.[collection]
        ) {
          return !!(
            formikProps?.errors?.[collection]?.[index] &&
            formikProps?.errors?.[collection]?.[index]?.[name]
          );
        }
      }
    }
  };
  const getErrorMessage = (formikProps, index, collection, name) => {
    if (formikProps?.errors?.[collection]) {
      if (formikProps?.errors?.[collection]?.[index]) {
        if (formikProps?.errors?.[collection]?.[index]?.[name]) {
          return formikProps?.errors[collection]?.[index]?.[name];
        }
      }
    }
    return "";
  };
  const getRemoveBtn = (certificates, arrayHelpers, index) => {
    return certificates && certificates.length > 1 ? (
      <Box className={styles.buttonWrapper}>
        <Box
          onKeyDown={() => {}}
          className={styles.trash}
          onClick={() => arrayHelpers.remove(index)}
        ></Box>
      </Box>
    ) : null;
  };
  return (
    <Box
      className={`formWrapper ${styles.vehicleFormSectionWrapper}`}
      data-testid="VehicleFormSection"
    >
      <Box className={`textboxDoubleWraper`}>
        <FormikControl
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <div className="blueSection"></div>
              </InputAdornment>
            ),
          }}
          label="License plate"
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          id="license-field"
          name="license_Plate_No"
          autoComplete="off"
          onChange={(e) => {
            formikProps?.setFieldValue("license_Plate_No", e.target.value);
          }}
          value={formikProps?.values.license_Plate_No}
          error={
            !!(
              formikProps?.touched.license_Plate_No &&
              formikProps?.errors.license_Plate_No
            )
          }
          errorMessage={
            formikProps?.errors.license_Plate_No
              ? formikProps?.errors?.license_Plate_No
              : null
          }
          customClass="licencePlate"
        />
      </Box>
      <Box className={`textboxDoubleWraper`}>
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("VIN no.")}
          id="vin"
          name="vin"
          placeholder={i18next.t("Enter VIN no.")}
          value={formikProps?.values.vin}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");
            formikProps?.setFieldTouched("vin", false);
            formikProps?.setFieldValue("vin", value);
          }}
          error={formikProps?.touched.vin && formikProps?.errors.vin}
          errorMessage={formikProps?.errors?.vin}
        />
      </Box>
      <Box className="textboxDoubleWraper">
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("Make")}
          id="make"
          name="make"
          placeholder={i18next.t("Enter the make")}
          value={formikProps?.values.make}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");
            formikProps?.setFieldTouched("make", false);
            formikProps?.setFieldValue("make", value);
          }}
          error={!!(formikProps?.touched.make && formikProps?.errors.make)}
          errorMessage={formikProps?.errors?.make}
        />
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box ${
            formikProps?.errors?.model ? "errorInput" : ""
          }`}
          label={i18next.t("Model")}
          id="model"
          name="model"
          placeholder={i18next.t("Enter the model")}
          value={formikProps?.values.model}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");

            formikProps?.setFieldTouched("model", false);
            formikProps?.setFieldValue("model", value);
          }}
          error={!!(formikProps?.touched.model && formikProps?.errors.model)}
          errorMessage={formikProps?.errors?.model}
        />
      </Box>

      <Box className="textboxDoubleWraper">
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("Milage Kms.")}
          id="kilometer_Stand"
          name="kilometer_Stand"
          placeholder={i18next.t("Enter the milage")}
          value={formikProps?.values.kilometer_Stand}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");
            formikProps?.setFieldTouched("kilometer_Stand", false);
            formikProps?.setFieldValue("kilometer_Stand", value);
          }}
          error={
            !!(
              formikProps?.touched.kilometer_Stand &&
              formikProps?.errors.kilometer_Stand
            )
          }
          errorMessage={formikProps?.errors?.kilometer_Stand}
        />
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box ${
            formikProps?.errors?.type ? "errorInput" : ""
          }`}
          label={i18next.t("Type of vehicle")}
          id="type"
          name="type"
          placeholder={i18next.t("Enter the type of the vehicle")}
          value={formikProps?.values.type}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");

            formikProps?.setFieldTouched("type", false);
            formikProps?.setFieldValue("type", value);
          }}
          error={!!(formikProps?.touched.type && formikProps?.errors.type)}
          errorMessage={formikProps?.errors?.type}
        />
      </Box>

      <Box className="textboxDoubleWraper">
        <FormikControl
          control="autocomplete"
          options={isDealerListLoading ? [] : dealerDropdownList}
          hiddenLabel
          noOptionsText={
            <Box>
              <Box>{i18next.t("No results found")}</Box>
            </Box>
          }
          loading={isDealerListLoading}
          size="small"
          variant="filled"
          className={`input-grp__box ${
            formikProps?.errors?.dealerName ? "errorInput" : ""
          }`}
          label={i18next.t("Dealer")}
          isSelect={false}
          id="dealerName"
          name="dealerName"
          placeholder={i18next.t("Enter dealer name")}
          value={formikProps?.values.dealerName}
          hasSubText={true}
          subTextField={{
            title: "key",
            id: "value",
          }}
          onChange={(e, value) => {
            setDropdownValue(value, dealerDropdownList, "dealerName");
          }}
          onInputChange={(event, newInputValue) => {
            onDealerInputChange(newInputValue);
          }}
          hasError={
            !!(
              formikProps?.touched.dealerName && formikProps?.errors.dealerName
            )
          }
          error={
            !!(
              formikProps?.touched.dealerName && formikProps?.errors.dealerName
            )
          }
          errorMessage={formikProps?.errors?.dealerName}
        />
        <FormikControl
          variant="filled"
          control="datepicker"
          hiddenLabel
          label={i18next.t("Date of 1st  admission")}
          id="date_of_Admission"
          name="date_of_Admission"
          value={formikProps?.values.date_of_Admission}
          placeholderText={i18next.t("choose 1st admission date")}
          format={"DD-MM-YYYY"}
          onChange={(date, { customInput, isTyping }) => {
            let input = document.getElementById("date_of_Admission-datepicker");

            formikProps?.setFieldTouched("date_of_Admission", true);

            if (!isTyping)
              return formikProps?.setFieldValue(
                "date_of_Admission",
                date.format()
              ); // user selects the date from the calendar and no needs for validation.
            if (!dateInputValidation(input, date)) {
              return false;
            }

            formikProps?.setFieldValue("date_of_Admission", date?.format());
          }}
          dateFormat={dateFormats.datePickerFormat}
          error={
            formikProps?.touched.date_of_Admission &&
            formikProps?.errors.date_of_Admission
          }
          errorMessage={formikProps?.errors?.date_of_Admission}
        />
      </Box>

      <Box className="fieldArrayWrapper">
        <Box className="fieldArrayTitle">
          <Box>{i18next.t("Assign certificate")}</Box>
          <Box className={styles.subTextNote}>
            {i18next.t("(Duplicaat certificaat niet toegestaan)")}
          </Box>
        </Box>
        <Box className="fieldArrayContent">
          <FieldArray
            name="certificates"
            render={(arrayHelpers) => {
              const certificates = formikProps?.values.certificates;
              return (
                <Box className="contentWrapper">
                  {certificates && certificates.length > 0
                    ? certificates
                        .filter(
                          (value) =>
                            value.certificate_Name !== "Combined_Certificate"
                        )
                        .map((value, index) => {
                          return (
                            <Box
                              className={"largeTextBoxThreeWrapper"}
                              key={value.name}
                            >
                              <FormikControl
                                variant="filled"
                                control="autocomplete"
                                label="Certificate"
                                options={assignCertificatesOptions}
                                hiddenLabel
                                id={`certificates_${index}.certificate_Name`}
                                name={`certificates.${index}.certificate_Name`}
                                size="small"
                                isSelect={true}
                                disabled={false}
                                onChange={(e, value) => {
                                  setDropdownValue(
                                    value,
                                    assignCertificatesOptions,
                                    `certificates.${index}.certificate_Name`,
                                    isDuplicateCertificate(
                                      formikProps?.values?.certificates,
                                      value
                                    )
                                  );
                                }}
                                value={
                                  formikProps?.values?.certificates[index]
                                    .certificate_Name
                                }
                                hasError={hasErrorCheck(
                                  formikProps,
                                  "certificates",
                                  "certificate_Name",
                                  index
                                )}
                                error={hasErrorCheck(
                                  formikProps,
                                  "certificates",
                                  "certificate_Name",
                                  index
                                )}
                                errorMessage={getErrorMessage(
                                  formikProps,
                                  index,
                                  "certificates",
                                  "certificate_Name"
                                )}
                                placeholder={i18next.t(
                                  "Select the certificate"
                                )}
                                className="input-grp__box select"
                              />

                              <FormikControl
                                variant="filled"
                                control="datepicker"
                                hiddenLabel
                                label={i18next.t("From date")}
                                id={`certificates_updatedDate_${index}`}
                                name={`certificates_updatedDate_${index}`}
                                value={
                                  formikProps?.values.certificates[index]
                                    .updatedDate
                                }
                                placeholderText={i18next.t(
                                  "Choose the date of the certificate"
                                )}
                                format={"DD-MM-YYYY"}
                                onChange={(date, { customInput, isTyping }) => {
                                  let input = document.getElementById(
                                    `certificates_updatedDate_${index}-datepicker`
                                  );

                                  formikProps?.setFieldTouched(
                                    `certificates.${index}.updatedDate`,
                                    true
                                  );

                                  if (!isTyping) {
                                    formikProps?.setFieldValue(
                                      `certificates.${index}.updatedDate`,
                                      date.format()
                                    ); // user selects the date from the calendar and no needs for validation.
                                  }
                                  if (!dateInputValidation(input, date)) {
                                    return false;
                                  }

                                  formikProps?.setFieldValue(
                                    `certificates.${index}.updatedDate`,
                                    date?.format()
                                  );
                                }}
                                error={hasErrorCheck(
                                  formikProps,
                                  "certificates",
                                  "updatedDate",
                                  index
                                )}
                                hasError={hasErrorCheck(
                                  formikProps,
                                  "certificates",
                                  "updatedDate",
                                  index
                                )}
                                errorMessage={getErrorMessage(
                                  formikProps,
                                  index,
                                  "certificates",
                                  "updatedDate"
                                )}
                              />
                              {getRemoveBtn(certificates, arrayHelpers, index)}
                            </Box>
                          );
                        })
                    : null}
                  <Box className="fieldArrayAction">
                    {" "}
                    <Button
                      type="button"
                      title="Add another certificate"
                      iconStyle={styles.plusIcon}
                      buttonType="muibtn-secondary-with-icon"
                      withIcon={true}
                      handleClick={() =>
                        arrayHelpers.push({
                          certificate_Name: "",
                          updatedDate: moment(new Date()).format("DD-MM-YYYY"),
                        })
                      }
                    />
                  </Box>
                </Box>
              );
            }}
          />
        </Box>
      </Box>

      <Box className="textboxDoubleWraper">
        <FormikControl
          variant="filled"
          control="autocomplete"
          label="Advertisement status"
          options={dropdownValueYesNoNeumeric}
          hiddenLabel
          id="ad_Status"
          name="ad_Status"
          size="small"
          isSelect={true}
          disabled={false}
          onChange={useCallback((e, value) => {
            setDropdownValue(
              value,
              dropdownValueYesNoNeumeric,
              "ad_Status",
              "ad_Status_Date"
            );
            // eslint-disable-next-line react-hooks/exhaustive-deps
          }, [])}
          value={formikProps?.values.ad_Status}
          hasError={
            !!(formikProps?.touched.ad_Status && formikProps?.errors.ad_Status)
          }
          error={
            !!(formikProps?.touched.ad_Status && formikProps?.errors.ad_Status)
          }
          errorMessage={formikProps?.errors?.ad_Status}
          placeholder={i18next.t("Select advertisement status")}
          className="input-grp__box select"
        />
      </Box>
    </Box>
  );
};
export default VehicleFormSection;
VehicleFormSection.propTypes = {
  assignCertificatesOptions: PropTypes.any,
};
